import React, { Component } from 'react';
import {
  Platform, View, StyleSheet, TextInput,
  Text, Image, StatusBar, BackHandler, Button
} from 'react-native';
import BookCover from '../assets/book_cover_full.svg';
import { useNavigate } from 'react-router-dom';
import '../styles/animation-product.css';
import ReactStars from "react-rating-stars-component";
// import { Button  } from 'react-native-elements';
// import Icon from 'react-native-vector-icons/Feather';

class SectionBookFlash extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data
    }
    
    //console.log("isi_section_buku = " + JSON.stringify(this.props.data));
  }

  goToDetail = async () => {
    //console.log("goToDetail" + this.props.data.id);
    //this.props.navigate('/etalaseDetails/' + this.props.data.id);
    this.props.navigate('/' + this.props.beranda + '/flash/' + this.props.data.id);
  }


  render() {
    return (
    <div>
        <div className="hidden lg:block">
            
            <div className="bg-white w-32 h-[310px] inline-block product-wrap rounded-[6px] ml-4 mr-2 pb-2  shadow-[2px_5px_8px_4px_rgba(0,0,0,0.4)]">
                <div className="w-32 h-[190px] max-w-xs overflow-hidden rounded-[6px] bg-white duration-300 ease-in-out product-transition">
                <img className='w-full rounded-[6px]' src={this.props.data.cover} alt="" onClick={this.goToDetail} />
                <div className="group-action">
                    <div className="shop-action vertical">
                    <div className="btn-opt" onClick={this.props.addWishlist}>
                        <svg width="16" height="15" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-[#414141] hover:stroke-white">
                        <path d="M18 6.77673C17.7932 6.10613 17.4228 5.47603 16.8547 4.91284C16.4075 4.46941 15.9433 4.17698 15.4776 4M9.39933 2.14593C7.72567 1.08425 5.02273 0.0803204 2.68853 2.46071C-2.85248 8.11136 6.64984 19 11 19C15.3501 19 24.8525 8.11136 19.3115 2.46072C16.9773 0.0803466 14.2744 1.08427 12.6007 2.14593C11.655 2.74582 10.345 2.74582 9.39933 2.14593Z" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </div>
                    <div className="btn-opt" onClick={this.props.viewBook}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-[#414141] hover:fill-white">
                        <path d="M20.7793 13.8746L21.3886 14.312L20.7793 13.8746ZM20.7793 10.1254L20.1701 10.5628L20.7793 10.1254ZM21.6631 12H20.9131H21.6631ZM3.22067 13.8746L3.82993 13.4372L3.22067 13.8746ZM3.22067 10.1254L2.61142 9.68801L3.22067 10.1254ZM2.33691 12H1.58691H2.33691ZM2.61142 14.312C3.47962 15.5214 4.77164 17.1105 6.35173 18.4043C7.92325 19.691 9.85905 20.75 12 20.75V19.25C10.3542 19.25 8.7491 18.4285 7.302 17.2437C5.86349 16.0659 4.6592 14.5923 3.82993 13.4372L2.61142 14.312ZM12 20.75C14.141 20.75 16.0768 19.691 17.6483 18.4043C19.2284 17.1105 20.5204 15.5214 21.3886 14.312L20.1701 13.4372C19.3408 14.5923 18.1365 16.0659 16.698 17.2437C15.2509 18.4285 13.6458 19.25 12 19.25V20.75ZM21.3886 9.68801C20.5204 8.47865 19.2284 6.88946 17.6483 5.59571C16.0768 4.30899 14.141 3.25 12 3.25V4.75C13.6458 4.75 15.2509 5.57146 16.698 6.75631C18.1365 7.93414 19.3408 9.40765 20.1701 10.5628L21.3886 9.68801ZM12 3.25C9.85905 3.25 7.92325 4.30899 6.35173 5.59572C4.77164 6.88946 3.47962 8.47865 2.61142 9.68801L3.82993 10.5628C4.6592 9.40765 5.86348 7.93414 7.302 6.75631C8.7491 5.57146 10.3542 4.75 12 4.75V3.25ZM21.3886 14.312C21.943 13.5398 22.4131 12.9286 22.4131 12H20.9131C20.9131 12.3585 20.794 12.5681 20.1701 13.4372L21.3886 14.312ZM20.1701 10.5628C20.794 11.4319 20.9131 11.6415 20.9131 12H22.4131C22.4131 11.0714 21.943 10.4602 21.3886 9.68801L20.1701 10.5628ZM3.82993 13.4372C3.20597 12.5681 3.08691 12.3585 3.08691 12H1.58691C1.58691 12.9286 2.05703 13.5398 2.61142 14.312L3.82993 13.4372ZM2.61142 9.68801C2.05703 10.4602 1.58691 11.0714 1.58691 12H3.08691C3.08691 11.6415 3.20597 11.4319 3.82993 10.5628L2.61142 9.68801ZM8.25001 12C8.25001 14.0711 9.92894 15.75 12 15.75V14.25C10.7574 14.25 9.75001 13.2426 9.75001 12H8.25001ZM12 15.75C14.0711 15.75 15.75 14.0711 15.75 12H14.25C14.25 13.2426 13.2426 14.25 12 14.25V15.75ZM15.75 12C15.75 9.92893 14.0711 8.25 12 8.25V9.75C13.2426 9.75 14.25 10.7574 14.25 12H15.75ZM12 8.25C9.92894 8.25 8.25001 9.92893 8.25001 12H9.75001C9.75001 10.7574 10.7574 9.75 12 9.75V8.25Z" />
                        </svg>
                    </div>
                    <div className="btn-opt" onClick={this.props.addCart}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-[#414141] hover:stroke-white">
                        <path d="M17 6H7.00002M17 6H18.3087C20.3944 6 21.4373 6 22.0335 6.66616C22.6298 7.33231 22.5146 8.36879 22.2843 10.4417L21.9884 13.1043C21.5183 17.3356 21.2832 19.4513 19.8594 20.7256C18.4356 22 16.2904 22 12 22C7.70962 22 5.56443 22 4.14063 20.7256C2.71683 19.4513 2.48176 17.3356 2.01161 13.1043L1.71577 10.4417C1.48544 8.36879 1.37028 7.33231 1.96652 6.66616C2.56276 6 3.60561 6 5.6913 6H7.00002M17 6C17 3.23858 14.7614 1 12 1C9.30679 1 7.1109 3.12938 7.00409 5.79641C7.00139 5.86394 7.00002 5.93181 7.00002 6" strokeWidth="1.5" />
                        <path d="M18 10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10Z" fill="#414141" />
                        <path d="M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z" fill="#414141" />
                        </svg>
                    </div>
                    </div>
                </div>
                </div>
                <div className="text-sm font-semibold ml-2 mt-2 dark:text-black line-clamp-1">{this.props.data.judul}</div>
                <div className="ml-2 text-[10px] text-[#999999]">{this.props.data.isbn==''?'-':this.props.data.isbn}</div>
                <div className="ml-2 text-[10px] text-[#999999]">{this.props.data.penerbit}</div>
                {(() => {
                if (this.props.data.formatted_harga_dasar == this.props.data.formatted_harga_akhir) {
                    return (
                        <div>
                            <div className="ml-2 text-base font-semibold text-greenWalang">Rp {this.props.data.formatted_harga_akhir}</div>
                            <div className="ml-2 line-through text-[10px] font-semibold text-[#999999]">&nbsp;</div>
                        </div>
                    )
                } else {
                    return (
                    <div>
                        <div className="ml-2 text-base font-semibold text-greenWalang">Rp {this.props.data.formatted_harga_akhir}</div>
                        <div className="ml-2 line-through text-[10px] font-semibold text-[#999999]">Rp {this.props.data.formatted_harga_dasar}</div>

                    </div>
                    )
                }
                })()}
                {this.props.data.rating>0 ?
                  <div className="flex">
                    <div className="ml-2">
                    <ReactStars
                    count={1}
                    size={12}
                    value={parseInt(this.props.data.rating)}
                    edit={false}
                    activeColor="#ffd700"
                    />
                    </div>
                    <div className="ml-1 text-[12px] text-[#999999]"> ({this.props.data.rating})</div>
                  </div>
                  :
                  <div className="ml-2 text-[12px] text-[#999999]">&nbsp;</div>
                }
                
                
                
            </div>
        </div>

        <div className="block lg:hidden">
            <div className="bg-white w-[118px] h-90 inline-block product-wrap rounded-[6px] ml-2 mr-2 pb-2 shadow-[0_5px_8px_3px_rgba(0,0,0,0.3)]">
                <div className="w-[118px] h-40 max-w-xs overflow-hidden rounded-[6px] bg-white product-transition">
                <img className='w-full rounded-[6px] shadow-md hover:shadow-xl transition-shadow duration-300 ease-in-out' src={this.props.data.cover} alt="" onClick={this.goToDetail} />
                <div className="group-action">
                    <div className="shop-action vertical">
                    <div className="btn-opt" onClick={this.props.addWishlist}>
                        <svg width="16" height="15" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-[#414141] hover:stroke-white">
                        <path d="M18 6.77673C17.7932 6.10613 17.4228 5.47603 16.8547 4.91284C16.4075 4.46941 15.9433 4.17698 15.4776 4M9.39933 2.14593C7.72567 1.08425 5.02273 0.0803204 2.68853 2.46071C-2.85248 8.11136 6.64984 19 11 19C15.3501 19 24.8525 8.11136 19.3115 2.46072C16.9773 0.0803466 14.2744 1.08427 12.6007 2.14593C11.655 2.74582 10.345 2.74582 9.39933 2.14593Z" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </div>
                    <div className="btn-opt" onClick={this.props.viewBook}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-[#414141] hover:fill-white">
                        <path d="M20.7793 13.8746L21.3886 14.312L20.7793 13.8746ZM20.7793 10.1254L20.1701 10.5628L20.7793 10.1254ZM21.6631 12H20.9131H21.6631ZM3.22067 13.8746L3.82993 13.4372L3.22067 13.8746ZM3.22067 10.1254L2.61142 9.68801L3.22067 10.1254ZM2.33691 12H1.58691H2.33691ZM2.61142 14.312C3.47962 15.5214 4.77164 17.1105 6.35173 18.4043C7.92325 19.691 9.85905 20.75 12 20.75V19.25C10.3542 19.25 8.7491 18.4285 7.302 17.2437C5.86349 16.0659 4.6592 14.5923 3.82993 13.4372L2.61142 14.312ZM12 20.75C14.141 20.75 16.0768 19.691 17.6483 18.4043C19.2284 17.1105 20.5204 15.5214 21.3886 14.312L20.1701 13.4372C19.3408 14.5923 18.1365 16.0659 16.698 17.2437C15.2509 18.4285 13.6458 19.25 12 19.25V20.75ZM21.3886 9.68801C20.5204 8.47865 19.2284 6.88946 17.6483 5.59571C16.0768 4.30899 14.141 3.25 12 3.25V4.75C13.6458 4.75 15.2509 5.57146 16.698 6.75631C18.1365 7.93414 19.3408 9.40765 20.1701 10.5628L21.3886 9.68801ZM12 3.25C9.85905 3.25 7.92325 4.30899 6.35173 5.59572C4.77164 6.88946 3.47962 8.47865 2.61142 9.68801L3.82993 10.5628C4.6592 9.40765 5.86348 7.93414 7.302 6.75631C8.7491 5.57146 10.3542 4.75 12 4.75V3.25ZM21.3886 14.312C21.943 13.5398 22.4131 12.9286 22.4131 12H20.9131C20.9131 12.3585 20.794 12.5681 20.1701 13.4372L21.3886 14.312ZM20.1701 10.5628C20.794 11.4319 20.9131 11.6415 20.9131 12H22.4131C22.4131 11.0714 21.943 10.4602 21.3886 9.68801L20.1701 10.5628ZM3.82993 13.4372C3.20597 12.5681 3.08691 12.3585 3.08691 12H1.58691C1.58691 12.9286 2.05703 13.5398 2.61142 14.312L3.82993 13.4372ZM2.61142 9.68801C2.05703 10.4602 1.58691 11.0714 1.58691 12H3.08691C3.08691 11.6415 3.20597 11.4319 3.82993 10.5628L2.61142 9.68801ZM8.25001 12C8.25001 14.0711 9.92894 15.75 12 15.75V14.25C10.7574 14.25 9.75001 13.2426 9.75001 12H8.25001ZM12 15.75C14.0711 15.75 15.75 14.0711 15.75 12H14.25C14.25 13.2426 13.2426 14.25 12 14.25V15.75ZM15.75 12C15.75 9.92893 14.0711 8.25 12 8.25V9.75C13.2426 9.75 14.25 10.7574 14.25 12H15.75ZM12 8.25C9.92894 8.25 8.25001 9.92893 8.25001 12H9.75001C9.75001 10.7574 10.7574 9.75 12 9.75V8.25Z" />
                        </svg>
                    </div>
                    <div className="btn-opt" onClick={this.props.addCart}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-[#414141] hover:stroke-white">
                        <path d="M17 6H7.00002M17 6H18.3087C20.3944 6 21.4373 6 22.0335 6.66616C22.6298 7.33231 22.5146 8.36879 22.2843 10.4417L21.9884 13.1043C21.5183 17.3356 21.2832 19.4513 19.8594 20.7256C18.4356 22 16.2904 22 12 22C7.70962 22 5.56443 22 4.14063 20.7256C2.71683 19.4513 2.48176 17.3356 2.01161 13.1043L1.71577 10.4417C1.48544 8.36879 1.37028 7.33231 1.96652 6.66616C2.56276 6 3.60561 6 5.6913 6H7.00002M17 6C17 3.23858 14.7614 1 12 1C9.30679 1 7.1109 3.12938 7.00409 5.79641C7.00139 5.86394 7.00002 5.93181 7.00002 6" strokeWidth="1.5" />
                        <path d="M18 10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10Z" fill="#414141" />
                        <path d="M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z" fill="#414141" />
                        </svg>
                    </div>
                    </div>
                </div>
                </div>
                <div className="text-sm font-semibold ml-2 mt-1 dark:text-black line-clamp-1">{this.props.data.judul}</div>
                {/*<div className="ml-2 text-xs text-[#999999]">{this.state.data.isbn}</div>*/}
                <div className="ml-2 text-[9px] text-[#999999]">{this.props.data.penerbit}</div>
                {(() => {
                if (this.props.data.formatted_harga_dasar == this.props.data.formatted_harga_akhir) {
                    return (
                        <div>
                            <div className="ml-2 text-sm font-semibold text-greenWalang">Rp {this.props.data.formatted_harga_akhir}</div>
                            <div className="ml-2 line-through text-[9px] font-semibold text-[#999999]">&nbsp;</div>
                        </div>
                    )
                } else {
                    return (
                    <div>
                        <div className="ml-2 text-sm font-semibold text-greenWalang">Rp {this.props.data.formatted_harga_akhir}</div>
                        <div className="ml-2 line-through text-[9px] font-semibold text-[#999999]">Rp {this.props.data.formatted_harga_dasar}</div>

                    </div>
                    )
                }
                })()}
                {this.props.data.rating>0 ?
                  <div className="flex">
                    <div className="ml-2">
                    <ReactStars
                    count={1}
                    size={9}
                    value={parseInt(this.props.data.rating)}
                    edit={false}
                    activeColor="#ffd700"
                    />
                    </div>
                    <div className="ml-1 text-[9px] text-[#999999]"> ({this.props.data.rating})</div>
                  </div>
                  :
                  <div className="ml-2 text-[9px] text-[#999999]">&nbsp;</div>
                }
                
                

            </div>
        </div>
    </div>
    )
  }
}

var styles = StyleSheet.create({
  caption: {
    fontFamily: "Montserrat-Regular",
    fontSize: 16,
    marginBottom: 12,
    color: "#212A3B"
  },
  placeholder: {
    fontFamily: "Montserrat-Regular",
    fontSize: 14
  },
  input: {
    flex: 1,
    backgroundColor: "#F6F6F6",
    borderRadius: 10,
    fontFamily: "Montserrat-Regular",
    fontSize: 14,
    padding: 12,
    color: '#34495e'
  },
  error: {
    fontFamily: "Montserrat-Regular",
    fontSize: 14,
    color: "#e74c3c",
    alignSelf: "flex-end"
  }


})

function WithNavigate(props) {
  let navigate = useNavigate();
  return <SectionBookFlash {...props} navigate={navigate} />
}

export default WithNavigate;